'use client';

import { useParams } from 'next/navigation';
import { Container, Grid, Title } from '@mantine/core';
import { SquareCard } from './SquareCard/SquareCard';
import styles from './SquareCardList.module.scss';

export const SquareCardList = ({ services, title }: { services: any[], title: string }) => {
  const { lang } = useParams();

  if (!services || services.length === 0) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', fontStyle: 'italic' }}>
        Aucun service disponible pour le moment.
      </div>
    );
  }

  const span = services.length === 4 ? 6 : 4;

  return (
    <Container size="lg">
      <h2 className={styles.title}>{title}</h2>
      <Grid gutter="lg">
        {services.map((service: any, index: number) => {
          const title =
            typeof service.title === 'object'
              ? service.title?.[lang as string]
              : service.title;

          return (
            <Grid.Col key={`${title}-${index}`} span={{ base: 12, sm: span }}>
              <SquareCard data={service} />
            </Grid.Col>
          );
        })}
      </Grid>
    </Container>
  );
};
